import React from 'react';

const CardTile = props => <div className={`ui-card ui-card-tile ${props.disabled ? "ui-card-button-disabled" : ""}`} style={props.style} onClick={() => props.disabled ? ()=>{} : props.onClick()}>
  <i className={`fad fa-${props.icon} colour-${props.colour}`}/>
  <p>{props.title}</p>
</div>;

export default CardTile;